// extracted by mini-css-extract-plugin
export default {"captionSlide":"image-swiper-module--caption-slide--4074d","imageSwiper":"image-swiper-module--image-swiper--27ba8"};